<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-info-data`]" width="1em" height="1em" v-bind="$attrs"><path d="M9 1.70312C13.031 1.70314 16.2988 4.97096 16.2988 9.00195C16.2988 13.033 13.031 16.3008 9 16.3008C4.96899 16.3008 1.70117 13.033 1.70117 9.00195C1.70119 4.97096 4.969 1.70314 9 1.70312ZM9 3.0332C5.70354 3.03321 3.03127 5.7055 3.03125 9.00195C3.03125 12.2984 5.70353 14.9707 9 14.9707C12.2965 14.9707 14.9688 12.2984 14.9688 9.00195C14.9687 5.7055 12.2965 3.03321 9 3.0332ZM9 8.43359C9.3671 8.43359 9.66476 8.7316 9.66504 9.09863V12.0508C9.66496 12.418 9.36722 12.7158 9 12.7158C8.63279 12.7158 8.33504 12.418 8.33496 12.0508V9.09863C8.33524 8.73161 8.63291 8.4336 9 8.43359ZM9 5.37402C9.52691 5.37402 9.95383 5.80225 9.9541 6.3291C9.95394 6.85605 9.52698 7.2832 9 7.2832C8.47303 7.28319 8.04606 6.85604 8.0459 6.3291C8.04617 5.80226 8.4731 5.37403 9 5.37402Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineInfoData',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
